import { Injectable, inject } from '@angular/core';
import { Actions, Store } from '@ngxs/store';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { NotificationsService } from '../services/notifications-service/notifications.service';
import { TranslationService } from '../transloco/services/translation.service';

@Injectable({ providedIn: 'root' })
export class ComponentBaseService {
    public store = inject(Store);
    public loaderService = inject(NgxUiLoaderService);
    public actions$ = inject(Actions);
    public notificationsService = inject(NotificationsService);
    public translationService = inject(TranslationService);
}
